(function () {
  if (window.__mpnIosFix) return; window.__mpnIosFix = true;
  var SEL = '.menu-drawer input[type="search"], .menu-drawer input[name="q"], header-drawer input[type="search"], header-drawer input[name="q"], #menu-drawer input[type="search"], #menu-drawer input[name="q"]';

  function cdSetup() {
    var d = document.querySelector('cart-drawer.mpn-cd');
    if (!d) return;
    function measure() {
      var f = d.querySelector('.mpn-cd__foot');
      var h = d.querySelector('.mpn-cd__head');
      if (f && f.offsetHeight) d.style.setProperty('--mpn-cd-foot', (f.offsetHeight + 16) + 'px');
      if (h && h.offsetHeight) d.style.setProperty('--mpn-cd-head', h.offsetHeight + 'px');
    }
    if (!d.__mpnCd) {
      d.__mpnCd = true;
      ['touchmove', 'wheel'].forEach(function (ev) {
        d.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      new MutationObserver(function () { setTimeout(measure, 30); }).observe(d, { attributes: true, childList: true, subtree: true });
      window.addEventListener('resize', measure);
    }
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cdSetup); else cdSetup();
  setTimeout(cdSetup, 1500);
  document.addEventListener('click', function () { setTimeout(cdSetup, 120); setTimeout(cdSetup, 600); }, true);

  function hideSitemaps() {
    if (!/\/search/.test(location.pathname) && !document.documentElement.classList.contains('mpn-so-open')) return;
    document.querySelectorAll('main a[href*="sitemap"], .mpn-so a[href*="sitemap"]').forEach(function (a) {
      if (a.closest('footer, .footer')) return;
      var item = a.closest('li') || a.closest('.grid__item') || a;
      item.classList.add('mpn-hide-sitemap');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideSitemaps); else hideSitemaps();
  new MutationObserver(function () { hideSitemaps(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* volet des filtres ouvert ? On ne regarde que le volet lui-meme (details direct de menu-drawer) : les rubriques de filtre
     ouvertes a l'interieur (1re rubrique ouverte d'office depuis nov. 2026) faisaient croire le volet toujours ouvert et cachaient badges et sliders des cartes */
  function facetsState() {
    var open = !!document.querySelector('.mobile-facets__disclosure[open], .mobile-facets__disclosure.menu-opening, menu-drawer.mobile-facets__wrapper > details[open], details.menu-opening > .mobile-facets');
    document.documentElement.classList.toggle('mpn-facets-open', open);
  }
  document.addEventListener('toggle', facetsState, true);
  document.addEventListener('click', function () { facetsState(); setTimeout(facetsState, 60); setTimeout(facetsState, 450); }, true);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(facetsState, 60); });
  setInterval(facetsState, 700);

  function fixViewport() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    window.scrollTo(0, y + 1);
    window.scrollTo(0, y);
    if (window.mpnSetVh) window.mpnSetVh();
  }
  var kbTimer = 0;
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input, textarea, select')) return;
    clearTimeout(kbTimer);
    kbTimer = setTimeout(function () {
      var a = document.activeElement;
      if (a && a.matches && a.matches('input, textarea, select')) return;
      fixViewport();
      setTimeout(fixViewport, 250);
    }, 60);
  }, true);
  if (window.visualViewport) {
    var lastH = window.visualViewport.height;
    window.visualViewport.addEventListener('resize', function () {
      var h = window.visualViewport.height;
      if (h > lastH + 80) { setTimeout(fixViewport, 50); }
      lastH = h;
    });
  }
  function openFrom(input, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (typeof window.mpnOpenSearch === 'function') window.mpnOpenSearch(input.value || '');
  }
  function prep(input) {
    if (input.__mpnRo) return;
    input.__mpnRo = true;
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('inputmode', 'none');
    input.classList.add('mpn-ro-search');
    input.addEventListener('touchend', function (e) { openFrom(input, e); }, { passive: false });
    input.addEventListener('mousedown', function (e) { openFrom(input, e); });
    input.addEventListener('focus', function () { input.blur(); }, true);
  }
  function scan() { document.querySelectorAll(SEL).forEach(prep); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 1500);
  document.addEventListener('click', function () { setTimeout(scan, 50); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header__icon--search, .header__icon--cart, #cart-icon-bubble, details-modal.header__search summary, [data-mpn-search-open]')) {
      fixViewport();
    }
  }, true);
})();
